import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApiService } from "../../services/api.service";
import { catchError, map, switchMap, throwError } from "rxjs";
import { BENI_CONTO_DEPOSITO, BENI_CONTO_DEPOSITO_SUCCESS, CHANGE_STATUS_VERIFICA, CHANGE_STATUS_VERIFICA_SUCCESS, CHIUDI_SCATOLA, CHIUDI_SCATOLA_SUCCESS, CHIUSURA_SCATOLE_BXL, CHIUSURA_SCATOLE_BXL_SUCCESS, ESPORTA_FILE_MAIL, ESPORTA_FILE_MAIL_SUCCESS, ESPORTA_FILE_XLS, ESPORTA_FILE_XLS_SUCCESS, EXISTS_SCATOLA_FLYER, EXISTS_SCATOLA_FLYER_SUCCESS, MOVIMENTAZIONE_CREATE_EVENT, MOVIMENTAZIONE_CREATE_EVENT_SUCCESS, MOVIMENTAZIONE_LIST, MOVIMENTAZIONE_LIST_SUCCESS, PACCHI_IN_GIACENZA, PACCHI_IN_GIACENZA_SUCCESS, RETRIVE_BOX_TO_CHECK, RETRIVE_BOX_TO_CHECK_SUCCESS, SCATOLA_NON_DISPONIBILE, SCATOLA_NON_DISPONIBILE_SUCCESS, STORICO_ANNUALE_CONTO_DEPOSITO, STORICO_ANNUALE_CONTO_DEPOSITO_SUCCESS, STORICO_OGGETTO_CONTO_DEPOSITO, STORICO_OGGETTO_CONTO_DEPOSITO_SUCCESS } from "./package-warehouse.actions";
import { IPacchiInGiacenzaResponse } from "../../interfaces/response-pacchi-giacenza";
import { IMovimentazioneListResponse } from "../../interfaces/movimentazione-list";
import { IMovimentazioneMailResponse } from "../../interfaces/movimentazione-mail";
import { IBeniContoDeposito } from "../../interfaces/beni-conto-deposito";
import { IResponseScatolaNonDisponibile } from "../../interfaces/scatola-non-disponibile";
import { IResponseChangeStatusVerifica } from "../../interfaces/change-status-verifica";
import { IResponseExistsScatolaFlyer } from "../../interfaces/exists-scatola-flyer";
import { IResponseChiudiScatola } from "../../interfaces/chiudi-scatola";
import { IResponseChiusuraScatoleBxl } from "../../interfaces/chiusura-scatole-bxl";
import { IResponseStoricoOggettoContoDeposito } from "../../interfaces/storico-oggetto-conto-deposito";
import { Store } from "@ngrx/store";
import { ADD_MESSAGE } from "../messages/messages.actions";
import { HttpErrorResponse } from "@angular/common/http";
import { IResponseMovimentazioneCreateEvent } from "../../interfaces/movimentazione-create-event";

@Injectable()
export class PackageWarehouseEffects {

  retrievePacchiGiacenza$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PACCHI_IN_GIACENZA),
      switchMap(() => this.api.retrievePacchiGiacenza()),
      map((responsePacchiInGiacenza: IPacchiInGiacenzaResponse) => {
        return PACCHI_IN_GIACENZA_SUCCESS({ responsePacchiInGiacenza });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMovimentazioneList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MOVIMENTAZIONE_LIST),
      switchMap(({payload}) => this.api.retrieveMovimentazioneList(payload)),
      map((responseMovimentazione: IMovimentazioneListResponse) => {
        return MOVIMENTAZIONE_LIST_SUCCESS({ responseMovimentazione });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveEsportaFileXls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ESPORTA_FILE_XLS),
      switchMap(({payload}) => this.api.retrieveEsportaXls(payload)),
      map((responseEsportaXls: any) => {
        return ESPORTA_FILE_XLS_SUCCESS({ responseEsportaXls });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveEsportaFileMail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ESPORTA_FILE_MAIL),
      switchMap(({payload}) => this.api.retrieveEsportaMail(payload)),
      map((responseEsportaMail: IMovimentazioneMailResponse) => {
        return ESPORTA_FILE_MAIL_SUCCESS({ responseEsportaMail });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retriveBoxToCheck$ = createEffect(() =>
      this.actions$.pipe(
        ofType(RETRIVE_BOX_TO_CHECK),
        switchMap(() => this.api.retriveVerificaMagazzinoPacchi()),
        map(responseVerificaBox => {
          return RETRIVE_BOX_TO_CHECK_SUCCESS({responseVerificaBox})
        }),
        catchError((error: HttpErrorResponse) => {
          this.addErrorMessage(error.message)
          return throwError({ error });
        })
      )
  )

  retrieveBeniContoDeposito$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BENI_CONTO_DEPOSITO),
      switchMap(() => this.api.retrieveBeniContoDeposito()),
      map((responseBeniContoDeposito: IBeniContoDeposito) => {
        return BENI_CONTO_DEPOSITO_SUCCESS({ responseBeniContoDeposito });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveScatolaNonDisponibile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SCATOLA_NON_DISPONIBILE),
      switchMap(({payload}) => this.api.retrieveScatolaNonDisponibile(payload)),
      map((responseScatolaNonDisponibile: IResponseScatolaNonDisponibile) => {
        return SCATOLA_NON_DISPONIBILE_SUCCESS({ responseScatolaNonDisponibile });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveChangeStatusVerifica$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHANGE_STATUS_VERIFICA),
      switchMap(({payload}) => this.api.retrieveChangeStatusVerifica(payload)),
      map((responseChangeStatusVerifica: IResponseChangeStatusVerifica) => {
        return CHANGE_STATUS_VERIFICA_SUCCESS({ responseChangeStatusVerifica });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveExistsScatolaFlyer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EXISTS_SCATOLA_FLYER),
      switchMap(({code}) => this.api.retrieveExistsScatolaFlyer(code)),
      map((responseExistsScatolaFlyer: IResponseExistsScatolaFlyer) => {
        return EXISTS_SCATOLA_FLYER_SUCCESS({ responseExistsScatolaFlyer });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveChiudiScatola$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHIUDI_SCATOLA),
      switchMap(({payload}) => this.api.retrieveChiudiScatola(payload)),
      map((responseChiudiScatola: IResponseChiudiScatola) => {
        return CHIUDI_SCATOLA_SUCCESS({ responseChiudiScatola });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveChiusuraScatoleBxl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHIUSURA_SCATOLE_BXL),
      switchMap(({payload}) => this.api.retrieveChiusuraScatoleBxl(payload)),
      map((responseChiusuraScatoleBxl: IResponseChiusuraScatoleBxl) => {
        return CHIUSURA_SCATOLE_BXL_SUCCESS({ responseChiusuraScatoleBxl });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveStoricoContoDeposito$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORICO_OGGETTO_CONTO_DEPOSITO),
      switchMap(({payload}) => this.api.retrieveStoricoContoDeposito(payload)),
      map((responseStoricoContoDeposito: IResponseStoricoOggettoContoDeposito) => {
        return STORICO_OGGETTO_CONTO_DEPOSITO_SUCCESS({ responseStoricoContoDeposito });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveStoricoAnnualeContoDeposito$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORICO_ANNUALE_CONTO_DEPOSITO),
      switchMap(({payload}) => this.api.retrieveStoricoAnnualeContoDeposito(payload)),
      map((responseStoricoAnnualeContoDeposito: any) => {
        return STORICO_ANNUALE_CONTO_DEPOSITO_SUCCESS({ responseStoricoAnnualeContoDeposito });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMovimentazioneCreateEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MOVIMENTAZIONE_CREATE_EVENT),
      switchMap(({payload}) => this.api.retrieveMovimentazioneCreateEvent(payload)),
      map((responseMovimentazioneCreateEvent: IResponseMovimentazioneCreateEvent) => {
        return MOVIMENTAZIONE_CREATE_EVENT_SUCCESS({ responseMovimentazioneCreateEvent });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store
  ) {}


  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
